import React from 'react';

// TODO: import List from '../updates/List';
import EventsScreen from '../events/Screen';

const Home = () => <EventsScreen />;

export default Home;



// WEBPACK FOOTER //
// ./src/home/index.js